import type {
  TMinorActionDataAcceptDealBreaker,
  TPortfolioNeighborhoodId,
} from '@kapitalist/contract/types'
import {skins} from '~/game/skins'
import Card from '~/models/game/Card'
import {PlayerGamePosition} from '~/models/game/GamePosition'
import type {TMinorActionUserFacingDescriptionData} from '~/models/game/MinorAction'
import MinorAction from '~/models/game/MinorAction'
import {sentenceCase, xVerbY} from '~/utils/language'

export default class MinorActionAcceptDealBreaker extends MinorAction<TMinorActionDataAcceptDealBreaker> {
  portfolioNeighborhoodId: TPortfolioNeighborhoodId // the dealbroken portfolio

  constructor(data: TMinorActionDataAcceptDealBreaker) {
    super(data)
    this.portfolioNeighborhoodId = data.portfolioNeighborhoodId
  }

  userFacingDescription(data: TMinorActionUserFacingDescriptionData): string {
    const {tense, skin, gamePosition, minorActor, majorActor} = data
    const currentPlayer =
      gamePosition instanceof PlayerGamePosition
        ? gamePosition.currentPlayer
        : undefined

    const {conjugatedVerb, xNoun, yNounPossessive} = xVerbY(
      tense,
      minorActor,
      tense === 'imperativePrompt' ? 'Accept' : 'accept',
      majorActor,
      currentPlayer?.id
    )

    // imperativePrompt drops actor + target: 'Accept Hostile Takeover', not 'You accept Bob's Hostile Takeover'
    const isPrompt = tense === 'imperativePrompt'
    return skins[skin].gameLogDescriptions.minorActionResponses.acceptDealBreaker({
      tense,
      actor: isPrompt
        ? undefined
        : xNoun === minorActor.username
          ? xNoun
          : sentenceCase(xNoun),
      verb: conjugatedVerb,
      targetPossessive: isPrompt ? undefined : yNounPossessive,
      cardName: Card.displayNameForCard('dealBreaker', skin),
      // TODO say "(forfeit your Dark Blue set)" in the prompt?
    })
  }
}
